<i18n>
{
	"en": {
		"noItemsText": "No benefits to show."
	},
	"fi": {
		"noItemsText": "Jäsenetuja ei löytynyt."
	}
}
</i18n>

<template>
	<div class="benefits">
		<v-container class="container--narrow">
			<v-card>
				<v-card-text v-html="data" />
			</v-card>
		</v-container>
	</div>
</template>

<style scoped>
.benefits >>> h2 {
	margin-bottom: 1rem;
}
.benefits >>> ul {
	margin-bottom: 1.5rem;
}
.benefits >>> ul li + li {
	margin-top:  0.5rem;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Benefits',

	computed: {
		...mapState({
			data: state => state.benefits,
		}),
	},

	mounted () {
		this.$api.Benefits.doRequest()
	},
}
</script>
